export const DEFAULT_TREATMENT_PROPS = { interventionId: 1, formularyId: 7 };

export const MOCK_INTERVENTION_LIST = [
  {
    interventionName: "Intervention 1",
    interventionId: 1,
    lastUpdatedBy: "User",
    lastUpdatedDate: "2026-03-15T12:54:40Z",
  },
  {
    interventionName: "Intervention 2",
    interventionId: 2,
    lastUpdatedBy: "User",
    lastUpdatedDate: "",
  },
];

export const MOCK_DYN_TAB_COMPLETE = [
  { key: "dressingappearance", value: "Dressing Appearance", isCompleted: 1 },
  { key: "debridement", value: "Debridement" },
];

export const TREATMENT_TAB_KEYS = [
  { key: "dressingappearance", name: "Dressing Appearance", stateKey: "dressingAppearance" },
  { key: "debridement", name: "Debridement", stateKey: "debridement" },
  { key: "woundcleanser", name: "Wound Cleanser", stateKey: "woundCleanser" },
  { key: "skinprotectant", name: "Skin Protectant", stateKey: "skinProtectant" },
  { key: "primarydressing", name: "Primary Dressing", stateKey: "primaryDressing" },
  { key: "secondarydressing", name: "Secondary Dressing", stateKey: "secondaryDressing" },
  { key: "compression", name: "Compression", stateKey: "compression" },
  { key: "modalities", name: "Modalities", stateKey: "modalities" },
  { key: "additionalcare", name: "Additional Care", stateKey: "additionalCare" },
  { key: "dressingchangefrequency", name: "Dressing Change Frequency", stateKey: "dressingChangeFrequency" },
];

export const MOCK_PRODUCT_CATEGORY_LIST = [
  {
    key: "44",
    name: "AWC Skin Protectants",
    options: [
      {
        materialNumber: "2675",
        materialCode: "MSC093001XL",
        productFamilyDesc: "Marathon Liquid Skin Protectant",
        materialDescription: "PROTECTANT,SKIN,MARATHON XL,LIQUID",
        isRecommended: 0,
      },
      {
        materialNumber: "3818",
        materialCode: "MSC093001XLH",
        productFamilyDesc: "Marathon Liquid Skin Protectant",
        materialDescription: "PROTECTANT,SKIN,MARATHON XL,LIQUID",
        isRecommended: 0,
      },
    ],
  },
];

export const MOCK_PRODUCT_CATEGORY_VIEW = [
  {
    key: "44",
    value: "2675",
  },
  {
    key: "44",
    value: "3818",
  },
];

export const MOCK_MULTISELECT_VIEW_DATA = { modalities: [{ key: "ultrasound", value: "Ultrasound" }] };
export const MOCK_MULTISELECT_LIST_OPTION_DATA = [
  { key: "negativepressurewoundtherapy", value: "Negative Pressure Wound Therapy" },
  { key: "highpressurewaterjet", value: "High Pressure Water Jet" },
  { key: "ultrasound", value: "Ultrasound" },
];

export const MOCK_DEBRIDMENT_EDIT_DATA = {
  configVersion: "1.0.0",
  careSetting: "hospital",
  isDebridementPerformed: "yes",
  notPerformedReason: null,
  prerequisites: [
    {
      key: "consent",
      policy: "Required",
      answer: "yes",
      value: null,
      reasonCode: null,
      reasonText: null,
    },
    {
      key: "performedBy",
      policy: "Required",
      answer: "yes",
      value: "mddodpmanppaproviderresident",
      reasonCode: null,
      reasonText: null,
    },
    {
      key: "providerOrder",
      policy: "RequiredWithOverride",
      answer: "yes",
      value: null,
      reasonCode: null,
      reasonText: null,
    },
    {
      key: "painBefore",
      policy: "RequiredWithOverride",
      answer: "yes",
      value: "8",
      reasonCode: null,
      reasonText: null,
    },
    {
      key: "photoPre",
      policy: "RequiredWithOverride",
      answer: "yes",
      value: "rightBefore",
      reasonCode: null,
      reasonText: null,
    },
  ],
  complianceFlags: [],
  surgicalDebridementProcedure: "surgical",
  nonExcisionalApproach: "cutaway",
  depthOfDebridement: "skin",
  necroticSubcutaneousTissue: [],
  necroticTissue: ["nails", "yellowslough-nontissuetype"],
  notApplicable: [],
  instrumentsUsed: ["scissors"],
  surfaceAreaOfNecroticSkinTissue: "10",
  surfaceAreaOfNecroticSubqTissue: "12",
  techniqueUsed: "orsterile",
  honeyDressing: null,
  painAfter: 8,
  postDebridementBleedingAmount: "small",
  stoppedBleedingContactPressure: "yes",
  patientId: "0001-104_act_1235",
  assessmentId: "11997",
  interventionId: 1019,
};

export const MOCK_DRESS_CHANGE = {
  data: {
    primary: {
      productCategory: [
        { productFamilyDesc: "Foam", materialDescription: "Foam Dressing", frequence: "1", frequenceType: "Days", recommended: "Yes" },
      ],
    },
    secondary: {
      productCategory: [
        { productFamilyDesc: "Gauze", materialDescription: "Gauze Dressing", frequence: "2", frequenceType: null, recommended: "No" },
      ],
    },
  },
};

export const MOCK_DEBRIDEMENT_FLAGS = [
  {
    prerequisiteKey: "consent",
    label: "Was verbal explanation of procedure given and consent received?",
    reasonCode: null,
    reasonText: "Not answered",
    severity: "Medium",
  },
  {
    prerequisiteKey: "performedBy",
    label: "Debridement performed by",
    reasonCode: "NA",
    reasonText: null,
    severity: "Medium",
  },
  {
    prerequisiteKey: "providerOrder",
    label: "provider",
    reasonCode: null,
    reasonText: null,
    severity: "Medium",
  },
];
